import { render } from "./ProjectDetailsComponent.vue?vue&type=template&id=376e36b6&scoped=true"
import script from "./ProjectDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsComponent.vue?vue&type=script&lang=js"

import "./ProjectDetailsComponent.vue?vue&type=style&index=0&id=376e36b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376e36b6"]])

export default __exports__